import { render, staticRenderFns } from "./general-settings.vue?vue&type=template&id=88c98838"
import script from "./general-settings.vue?vue&type=script&lang=ts"
export * from "./general-settings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports